<template>
    <div class="home">
        <b-img src="images/bild.jpg" fluid />
        <b-row class="lg_frame mb-5 mx-0 p-3">BESCHAFFUNGSPLATTFORM</b-row>

        <p class="lg_title" v-html="$t('presentation.tender_title')" />
        <p class="lg_subtitle" v-html="$t('presentation.tender_subtitle')" />
        <p class="lg_text" v-html="$t('presentation.tender_text')" />
        <p class="lg_list" v-html="$t('presentation.tender_list')" />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'ausschreibungen',
        data() {
            return {};
        },
        computed: {
            ...mapGetters({
                auth: 'auth/auth'
            })
        }
    }
</script>